<div class="pure-price">
    <div class="high-value-title">
        <span class="head">PRICE REALIZATION BRIDGE</span>
    </div>
    <div echarts [options]="chartOption" class="demo-chart" id="canvas" (chartClick)="onChartClick($event)"></div>
    <div class="per-container">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>

<div class="deep-dive-block">
    <div class="block1">
        <div class="high-value-title">
            <span class="head">TOTAL PRICE IMPACT BREAKDOWN</span>
        </div>
        <div echarts [options]="totalPriceChart" class="overall-price-chart" (chartClick)="onChartClick($event)"></div>
        <div class="totalper">
            <div class="pure-perc">
                {{ totalPricePercVal.total_price_impact_per * 100 | percent }}
            </div>
            <div class="pure-perc">
                {{ totalPricePercVal.comparable_customer_specs_per * 100 | percent }}
            </div>
            <div class="pure-perc">
                {{ totalPricePercVal.unmapped_per * 100 | percent }}
            </div>
            <div class="pure-perc">
                {{ totalPricePercVal.pricerealizedby_pricespec_prices_per * 100 | percent }}
            </div>
        </div>
    </div>
    <div class="block2">
        <div class="high-value-title">
            <span class="head">2023 SALES BREAKDOWN</span>
        </div>
        <div echarts [options]="salesBreakChart" class="onQuote" (chartClick)="onChartClick($event)"></div>
       
    </div>
</div>